// AUTO-GENERATED. Do not edit by hand.
// Source: scripts/build-static-config.mjs (assets in src/assets/hints/)

import _img_0 from "../assets/hints/en/faq_door_angle_img_1.png";
import _img_1 from "../assets/hints/en/faq_door_aperture_img_1.png";
import _img_2 from "../assets/hints/en/faq_door_aperture_img_2.png";
import _img_3 from "../assets/hints/en/faq_door_aperture_img_3.png";
import _img_4 from "../assets/hints/en/faq_door_aperture_img_4.png";
import _img_5 from "../assets/hints/en/faq_door_aperture_img_5.png";
import _img_6 from "../assets/hints/en/faq_door_aperture_img_6.png";
import _img_7 from "../assets/hints/en/faq_door_aperture_img_7.png";
import _img_8 from "../assets/hints/en/faq_door_aperture_img_8.png";
import _img_9 from "../assets/hints/en/faq_door_classification_img_1.png";
import _img_10 from "../assets/hints/en/faq_door_classification_img_2.png";
import _img_11 from "../assets/hints/en/faq_door_classification_img_3.png";
import _img_12 from "../assets/hints/en/faq_door_classification_img_4.png";
import _img_13 from "../assets/hints/en/faq_door_forces_img_1.png";
import _img_14 from "../assets/hints/en/faq_door_forces_img_2.png";
import _img_15 from "../assets/hints/en/faq_door_forces_img_3.png";
import _img_16 from "../assets/hints/en/faq_door_gravity_img_1.jpg";
import _img_17 from "../assets/hints/en/faq_flotation_img_1.png";
import _img_18 from "../assets/hints/en/faq_flotation_img_2.png";
import _img_19 from "../assets/hints/en/faq_flotation_img_3.jpg";
import _img_20 from "../assets/hints/en/faq_flotation_img_4.jpg";
import _img_21 from "../assets/hints/en/faq_flotation_img_5.jpg";
import _img_22 from "../assets/hints/en/faq_flotation_img_6.png";
import _img_23 from "../assets/hints/en/faq_net_aperture_img_1.png";
import _img_24 from "../assets/hints/en/faq_net_aperture_img_2.png";
import _img_25 from "../assets/hints/en/faq_net_aperture_img_3.png";
import _img_26 from "../assets/hints/en/faq_net_efficiency_img_1.png";
import _img_27 from "../assets/hints/en/faq_net_efficiency_img_2.png";
import _img_28 from "../assets/hints/en/faq_net_efficiency_img_3.png";
import _img_29 from "../assets/hints/en/faq_net_length_img_1.png";
import _img_30 from "../assets/hints/en/faq_net_length_img_2.png";
import _img_31 from "../assets/hints/en/faq_net_length_img_3.png";
import _img_32 from "../assets/hints/en/faq_net_length_img_4.png";
import _img_33 from "../assets/hints/en/faq_pie_gallo_length_img_1.png";
import _img_34 from "../assets/hints/en/faq_pie_gallo_length_img_2.png";
import _img_35 from "../assets/hints/en/faq_tilt_angle_img_1.png";
import _img_36 from "../assets/hints/en/faq_tilt_angle_img_2.png";
import _img_37 from "../assets/hints/en/faq_tilt_angle_img_3.png";
import _img_38 from "../assets/hints/en/faq_tilt_angle_img_4.png";
import _img_39 from "../assets/hints/en/faq_tilt_angle_img_5.png";
import _img_40 from "../assets/hints/en/faq_tilt_angle_img_6.png";
import _img_41 from "../assets/hints/en/faq_tilt_angle_img_7.png";
import _img_42 from "../assets/hints/en/faq_tilt_angle_img_8.png";
import _img_43 from "../assets/hints/en/faq_tilt_angle_img_9.png";
import _img_44 from "../assets/hints/en/faq_vertical_aperture_img_1.png";
import _img_45 from "../assets/hints/en/form_cloths_hints_img_1.png";
import _img_46 from "../assets/hints/en/form_cloths_hints_img_2.png";
import _img_47 from "../assets/hints/en/form_cloths_hints_img_3.png";
import _img_48 from "../assets/hints/en/form_flotation_hints_img_1.jpg";
import _img_49 from "../assets/hints/en/form_flotation_hints_img_2.jpg";
import _img_50 from "../assets/hints/en/form_flotation_hints_img_3.jpg";
import _img_51 from "../assets/hints/en/form_tow_cable_hints_img_1.png";
import _img_52 from "../assets/hints/en/form_tow_cable_hints_img_2.jpg";
import _img_53 from "../assets/hints/en/form_tow_cable_hints_img_3.png";
import _img_54 from "../assets/hints/en/form_tow_cable_hints_img_4.png";
import _img_55 from "../assets/hints/en/form_tow_cable_hints_img_5.jpg";
import _img_56 from "../assets/hints/en/form_trawl_gates_hints_img_1.jpg";
import _img_57 from "../assets/hints/en/form_trawl_gates_hints_img_2.jpg";
import _img_58 from "../assets/hints/en/form_trawl_gates_hints_img_3.jpg";
import _img_59 from "../assets/hints/en/form_trawl_gates_hints_img_4.jpg";
import _img_60 from "../assets/hints/en/form_trawl_gates_hints_img_5.jpg";
import _img_61 from "../assets/hints/en/form_trawl_gates_hints_img_6.jpg";
import _img_62 from "../assets/hints/en/form_winches_hints_img_1.jpg";
import _img_63 from "../assets/hints/en/form_winches_hints_img_2.jpg";
import _img_64 from "../assets/hints/es/faq_door_angle_img_1.jpg";
import _img_65 from "../assets/hints/es/faq_door_aperture_img_1.png";
import _img_66 from "../assets/hints/es/faq_door_aperture_img_2.png";
import _img_67 from "../assets/hints/es/faq_door_aperture_img_3.jpg";
import _img_68 from "../assets/hints/es/faq_door_aperture_img_4.png";
import _img_69 from "../assets/hints/es/faq_door_aperture_img_5.png";
import _img_70 from "../assets/hints/es/faq_door_aperture_img_6.png";
import _img_71 from "../assets/hints/es/faq_door_aperture_img_7.png";
import _img_72 from "../assets/hints/es/faq_door_aperture_img_8.png";
import _img_73 from "../assets/hints/es/faq_door_classification_img_1.png";
import _img_74 from "../assets/hints/es/faq_door_classification_img_2.png";
import _img_75 from "../assets/hints/es/faq_door_classification_img_3.png";
import _img_76 from "../assets/hints/es/faq_door_classification_img_4.png";
import _img_77 from "../assets/hints/es/faq_door_forces_img_1.png";
import _img_78 from "../assets/hints/es/faq_door_forces_img_2.png";
import _img_79 from "../assets/hints/es/faq_door_forces_img_3.png";
import _img_80 from "../assets/hints/es/faq_door_gravity_img_1.png";
import _img_81 from "../assets/hints/es/faq_flotation_img_1.jpg";
import _img_82 from "../assets/hints/es/faq_flotation_img_2.png";
import _img_83 from "../assets/hints/es/faq_flotation_img_3.png";
import _img_84 from "../assets/hints/es/faq_flotation_img_4.png";
import _img_85 from "../assets/hints/es/faq_flotation_img_5.png";
import _img_86 from "../assets/hints/es/faq_flotation_img_6.png";
import _img_87 from "../assets/hints/es/faq_net_aperture_img_1.png";
import _img_88 from "../assets/hints/es/faq_net_aperture_img_2.png";
import _img_89 from "../assets/hints/es/faq_net_aperture_img_3.png";
import _img_90 from "../assets/hints/es/faq_net_efficiency_img_1.png";
import _img_91 from "../assets/hints/es/faq_net_efficiency_img_2.png";
import _img_92 from "../assets/hints/es/faq_net_efficiency_img_3.jpg";
import _img_93 from "../assets/hints/es/faq_net_length_img_1.png";
import _img_94 from "../assets/hints/es/faq_net_length_img_2.png";
import _img_95 from "../assets/hints/es/faq_net_length_img_3.png";
import _img_96 from "../assets/hints/es/faq_net_length_img_4.png";
import _img_97 from "../assets/hints/es/faq_pie_gallo_length_img_1.jpg";
import _img_98 from "../assets/hints/es/faq_pie_gallo_length_img_2.jpg";
import _img_99 from "../assets/hints/es/faq_tilt_angle_img_1.png";
import _img_100 from "../assets/hints/es/faq_tilt_angle_img_2.png";
import _img_101 from "../assets/hints/es/faq_tilt_angle_img_3.png";
import _img_102 from "../assets/hints/es/faq_tilt_angle_img_4.png";
import _img_103 from "../assets/hints/es/faq_tilt_angle_img_5.png";
import _img_104 from "../assets/hints/es/faq_tilt_angle_img_6.png";
import _img_105 from "../assets/hints/es/faq_tilt_angle_img_7.png";
import _img_106 from "../assets/hints/es/faq_tilt_angle_img_8.png";
import _img_107 from "../assets/hints/es/faq_tilt_angle_img_9.png";
import _img_108 from "../assets/hints/es/faq_vertical_aperture_img_1.png";
import _img_109 from "../assets/hints/es/form_cloths_hints_img_1.png";
import _img_110 from "../assets/hints/es/form_cloths_hints_img_2.png";
import _img_111 from "../assets/hints/es/form_cloths_hints_img_3.png";
import _img_112 from "../assets/hints/es/form_flotation_hints_img_1.jpg";
import _img_113 from "../assets/hints/es/form_flotation_hints_img_2.jpg";
import _img_114 from "../assets/hints/es/form_flotation_hints_img_3.jpg";
import _img_115 from "../assets/hints/es/form_tow_cable_hints_img_1.png";
import _img_116 from "../assets/hints/es/form_tow_cable_hints_img_2.png";
import _img_117 from "../assets/hints/es/form_tow_cable_hints_img_3.png";
import _img_118 from "../assets/hints/es/form_tow_cable_hints_img_4.png";
import _img_119 from "../assets/hints/es/form_tow_cable_hints_img_5.png";
import _img_120 from "../assets/hints/es/form_trawl_gates_hints_img_1.jpg";
import _img_121 from "../assets/hints/es/form_trawl_gates_hints_img_2.jpg";
import _img_122 from "../assets/hints/es/form_trawl_gates_hints_img_3.jpg";
import _img_123 from "../assets/hints/es/form_trawl_gates_hints_img_4.jpg";
import _img_124 from "../assets/hints/es/form_trawl_gates_hints_img_5.jpg";
import _img_125 from "../assets/hints/es/form_trawl_gates_hints_img_6.jpg";
import _img_126 from "../assets/hints/es/form_winches_hints_img_1.jpg";
import _img_127 from "../assets/hints/es/form_winches_hints_img_2.jpg";
import _img_128 from "../assets/hints/fr/faq_door_angle_img_1.png";
import _img_129 from "../assets/hints/fr/faq_door_aperture_img_1.png";
import _img_130 from "../assets/hints/fr/faq_door_aperture_img_2.png";
import _img_131 from "../assets/hints/fr/faq_door_aperture_img_3.png";
import _img_132 from "../assets/hints/fr/faq_door_aperture_img_4.png";
import _img_133 from "../assets/hints/fr/faq_door_aperture_img_5.png";
import _img_134 from "../assets/hints/fr/faq_door_aperture_img_6.png";
import _img_135 from "../assets/hints/fr/faq_door_aperture_img_7.png";
import _img_136 from "../assets/hints/fr/faq_door_aperture_img_8.png";
import _img_137 from "../assets/hints/fr/faq_door_classification_img_1.png";
import _img_138 from "../assets/hints/fr/faq_door_classification_img_2.png";
import _img_139 from "../assets/hints/fr/faq_door_classification_img_3.png";
import _img_140 from "../assets/hints/fr/faq_door_classification_img_4.png";
import _img_141 from "../assets/hints/fr/faq_door_forces_img_1.png";
import _img_142 from "../assets/hints/fr/faq_door_forces_img_2.png";
import _img_143 from "../assets/hints/fr/faq_door_forces_img_3.png";
import _img_144 from "../assets/hints/fr/faq_door_gravity_img_1.jpg";
import _img_145 from "../assets/hints/fr/faq_flotation_img_1.png";
import _img_146 from "../assets/hints/fr/faq_flotation_img_2.png";
import _img_147 from "../assets/hints/fr/faq_flotation_img_3.jpg";
import _img_148 from "../assets/hints/fr/faq_flotation_img_4.jpg";
import _img_149 from "../assets/hints/fr/faq_flotation_img_5.jpg";
import _img_150 from "../assets/hints/fr/faq_flotation_img_6.png";
import _img_151 from "../assets/hints/fr/faq_net_aperture_img_1.png";
import _img_152 from "../assets/hints/fr/faq_net_aperture_img_2.png";
import _img_153 from "../assets/hints/fr/faq_net_aperture_img_3.png";
import _img_154 from "../assets/hints/fr/faq_net_efficiency_img_1.png";
import _img_155 from "../assets/hints/fr/faq_net_efficiency_img_2.png";
import _img_156 from "../assets/hints/fr/faq_net_efficiency_img_3.png";
import _img_157 from "../assets/hints/fr/faq_net_length_img_1.png";
import _img_158 from "../assets/hints/fr/faq_net_length_img_2.png";
import _img_159 from "../assets/hints/fr/faq_net_length_img_3.png";
import _img_160 from "../assets/hints/fr/faq_net_length_img_4.png";
import _img_161 from "../assets/hints/fr/faq_pie_gallo_length_img_1.png";
import _img_162 from "../assets/hints/fr/faq_pie_gallo_length_img_2.png";
import _img_163 from "../assets/hints/fr/faq_tilt_angle_img_1.png";
import _img_164 from "../assets/hints/fr/faq_tilt_angle_img_2.png";
import _img_165 from "../assets/hints/fr/faq_tilt_angle_img_3.png";
import _img_166 from "../assets/hints/fr/faq_tilt_angle_img_4.png";
import _img_167 from "../assets/hints/fr/faq_tilt_angle_img_5.png";
import _img_168 from "../assets/hints/fr/faq_tilt_angle_img_6.png";
import _img_169 from "../assets/hints/fr/faq_tilt_angle_img_7.png";
import _img_170 from "../assets/hints/fr/faq_tilt_angle_img_8.png";
import _img_171 from "../assets/hints/fr/faq_tilt_angle_img_9.png";
import _img_172 from "../assets/hints/fr/faq_vertical_aperture_img_1.png";
import _img_173 from "../assets/hints/fr/form_cloths_hints_img_1.png";
import _img_174 from "../assets/hints/fr/form_cloths_hints_img_2.png";
import _img_175 from "../assets/hints/fr/form_cloths_hints_img_3.png";
import _img_176 from "../assets/hints/fr/form_flotation_hints_img_1.jpg";
import _img_177 from "../assets/hints/fr/form_flotation_hints_img_2.jpg";
import _img_178 from "../assets/hints/fr/form_flotation_hints_img_3.jpg";
import _img_179 from "../assets/hints/fr/form_tow_cable_hints_img_1.png";
import _img_180 from "../assets/hints/fr/form_tow_cable_hints_img_2.jpg";
import _img_181 from "../assets/hints/fr/form_tow_cable_hints_img_3.png";
import _img_182 from "../assets/hints/fr/form_tow_cable_hints_img_4.png";
import _img_183 from "../assets/hints/fr/form_tow_cable_hints_img_5.jpg";
import _img_184 from "../assets/hints/fr/form_trawl_gates_hints_img_1.jpg";
import _img_185 from "../assets/hints/fr/form_trawl_gates_hints_img_2.jpg";
import _img_186 from "../assets/hints/fr/form_trawl_gates_hints_img_3.jpg";
import _img_187 from "../assets/hints/fr/form_trawl_gates_hints_img_4.jpg";
import _img_188 from "../assets/hints/fr/form_trawl_gates_hints_img_5.jpg";
import _img_189 from "../assets/hints/fr/form_trawl_gates_hints_img_6.jpg";
import _img_190 from "../assets/hints/fr/form_winches_hints_img_1.jpg";
import _img_191 from "../assets/hints/fr/form_winches_hints_img_2.jpg";
import _img_192 from "../assets/hints/it/faq_door_angle_img_1.png";
import _img_193 from "../assets/hints/it/faq_door_aperture_img_1.png";
import _img_194 from "../assets/hints/it/faq_door_aperture_img_2.png";
import _img_195 from "../assets/hints/it/faq_door_aperture_img_3.png";
import _img_196 from "../assets/hints/it/faq_door_aperture_img_4.png";
import _img_197 from "../assets/hints/it/faq_door_aperture_img_5.png";
import _img_198 from "../assets/hints/it/faq_door_aperture_img_6.png";
import _img_199 from "../assets/hints/it/faq_door_aperture_img_7.png";
import _img_200 from "../assets/hints/it/faq_door_aperture_img_8.png";
import _img_201 from "../assets/hints/it/faq_door_classification_img_1.png";
import _img_202 from "../assets/hints/it/faq_door_classification_img_2.png";
import _img_203 from "../assets/hints/it/faq_door_classification_img_3.png";
import _img_204 from "../assets/hints/it/faq_door_classification_img_4.png";
import _img_205 from "../assets/hints/it/faq_door_forces_img_1.png";
import _img_206 from "../assets/hints/it/faq_door_forces_img_2.png";
import _img_207 from "../assets/hints/it/faq_door_forces_img_3.png";
import _img_208 from "../assets/hints/it/faq_door_gravity_img_1.jpg";
import _img_209 from "../assets/hints/it/faq_flotation_img_1.png";
import _img_210 from "../assets/hints/it/faq_flotation_img_2.png";
import _img_211 from "../assets/hints/it/faq_flotation_img_3.jpg";
import _img_212 from "../assets/hints/it/faq_flotation_img_4.jpg";
import _img_213 from "../assets/hints/it/faq_flotation_img_5.jpg";
import _img_214 from "../assets/hints/it/faq_flotation_img_6.png";
import _img_215 from "../assets/hints/it/faq_net_aperture_img_1.png";
import _img_216 from "../assets/hints/it/faq_net_aperture_img_2.png";
import _img_217 from "../assets/hints/it/faq_net_aperture_img_3.png";
import _img_218 from "../assets/hints/it/faq_net_efficiency_img_1.png";
import _img_219 from "../assets/hints/it/faq_net_efficiency_img_2.png";
import _img_220 from "../assets/hints/it/faq_net_efficiency_img_3.png";
import _img_221 from "../assets/hints/it/faq_net_length_img_1.png";
import _img_222 from "../assets/hints/it/faq_net_length_img_2.png";
import _img_223 from "../assets/hints/it/faq_net_length_img_3.png";
import _img_224 from "../assets/hints/it/faq_net_length_img_4.png";
import _img_225 from "../assets/hints/it/faq_pie_gallo_length_img_1.png";
import _img_226 from "../assets/hints/it/faq_pie_gallo_length_img_2.png";
import _img_227 from "../assets/hints/it/faq_tilt_angle_img_1.png";
import _img_228 from "../assets/hints/it/faq_tilt_angle_img_2.png";
import _img_229 from "../assets/hints/it/faq_tilt_angle_img_3.png";
import _img_230 from "../assets/hints/it/faq_tilt_angle_img_4.png";
import _img_231 from "../assets/hints/it/faq_tilt_angle_img_5.png";
import _img_232 from "../assets/hints/it/faq_tilt_angle_img_6.png";
import _img_233 from "../assets/hints/it/faq_tilt_angle_img_7.png";
import _img_234 from "../assets/hints/it/faq_tilt_angle_img_8.png";
import _img_235 from "../assets/hints/it/faq_tilt_angle_img_9.png";
import _img_236 from "../assets/hints/it/faq_vertical_aperture_img_1.png";
import _img_237 from "../assets/hints/it/form_cloths_hints_img_1.png";
import _img_238 from "../assets/hints/it/form_cloths_hints_img_2.png";
import _img_239 from "../assets/hints/it/form_cloths_hints_img_3.png";
import _img_240 from "../assets/hints/it/form_flotation_hints_img_1.jpg";
import _img_241 from "../assets/hints/it/form_flotation_hints_img_2.jpg";
import _img_242 from "../assets/hints/it/form_flotation_hints_img_3.jpg";
import _img_243 from "../assets/hints/it/form_tow_cable_hints_img_1.png";
import _img_244 from "../assets/hints/it/form_tow_cable_hints_img_2.jpg";
import _img_245 from "../assets/hints/it/form_tow_cable_hints_img_3.png";
import _img_246 from "../assets/hints/it/form_tow_cable_hints_img_4.png";
import _img_247 from "../assets/hints/it/form_tow_cable_hints_img_5.jpg";
import _img_248 from "../assets/hints/it/form_trawl_gates_hints_img_1.jpg";
import _img_249 from "../assets/hints/it/form_trawl_gates_hints_img_2.jpg";
import _img_250 from "../assets/hints/it/form_trawl_gates_hints_img_3.jpg";
import _img_251 from "../assets/hints/it/form_trawl_gates_hints_img_4.jpg";
import _img_252 from "../assets/hints/it/form_trawl_gates_hints_img_5.jpg";
import _img_253 from "../assets/hints/it/form_trawl_gates_hints_img_6.jpg";
import _img_254 from "../assets/hints/it/form_winches_hints_img_1.jpg";
import _img_255 from "../assets/hints/it/form_winches_hints_img_2.jpg";
import _img_256 from "../assets/hints/pt/faq_door_angle_img_1.png";
import _img_257 from "../assets/hints/pt/faq_door_aperture_img_1.png";
import _img_258 from "../assets/hints/pt/faq_door_aperture_img_2.png";
import _img_259 from "../assets/hints/pt/faq_door_aperture_img_3.png";
import _img_260 from "../assets/hints/pt/faq_door_aperture_img_4.png";
import _img_261 from "../assets/hints/pt/faq_door_aperture_img_5.png";
import _img_262 from "../assets/hints/pt/faq_door_aperture_img_6.png";
import _img_263 from "../assets/hints/pt/faq_door_aperture_img_7.png";
import _img_264 from "../assets/hints/pt/faq_door_aperture_img_8.png";
import _img_265 from "../assets/hints/pt/faq_door_classification_img_1.png";
import _img_266 from "../assets/hints/pt/faq_door_classification_img_2.png";
import _img_267 from "../assets/hints/pt/faq_door_classification_img_3.png";
import _img_268 from "../assets/hints/pt/faq_door_classification_img_4.png";
import _img_269 from "../assets/hints/pt/faq_door_forces_img_1.png";
import _img_270 from "../assets/hints/pt/faq_door_forces_img_2.png";
import _img_271 from "../assets/hints/pt/faq_door_forces_img_3.png";
import _img_272 from "../assets/hints/pt/faq_door_gravity_img_1.jpg";
import _img_273 from "../assets/hints/pt/faq_flotation_img_1.png";
import _img_274 from "../assets/hints/pt/faq_flotation_img_2.png";
import _img_275 from "../assets/hints/pt/faq_flotation_img_3.jpg";
import _img_276 from "../assets/hints/pt/faq_flotation_img_4.jpg";
import _img_277 from "../assets/hints/pt/faq_flotation_img_5.jpg";
import _img_278 from "../assets/hints/pt/faq_flotation_img_6.png";
import _img_279 from "../assets/hints/pt/faq_net_aperture_img_1.png";
import _img_280 from "../assets/hints/pt/faq_net_aperture_img_2.png";
import _img_281 from "../assets/hints/pt/faq_net_aperture_img_3.png";
import _img_282 from "../assets/hints/pt/faq_net_efficiency_img_1.png";
import _img_283 from "../assets/hints/pt/faq_net_efficiency_img_2.png";
import _img_284 from "../assets/hints/pt/faq_net_efficiency_img_3.png";
import _img_285 from "../assets/hints/pt/faq_net_length_img_1.png";
import _img_286 from "../assets/hints/pt/faq_net_length_img_2.png";
import _img_287 from "../assets/hints/pt/faq_net_length_img_3.png";
import _img_288 from "../assets/hints/pt/faq_net_length_img_4.png";
import _img_289 from "../assets/hints/pt/faq_pie_gallo_length_img_1.png";
import _img_290 from "../assets/hints/pt/faq_pie_gallo_length_img_2.png";
import _img_291 from "../assets/hints/pt/faq_tilt_angle_img_1.png";
import _img_292 from "../assets/hints/pt/faq_tilt_angle_img_2.png";
import _img_293 from "../assets/hints/pt/faq_tilt_angle_img_3.png";
import _img_294 from "../assets/hints/pt/faq_tilt_angle_img_4.png";
import _img_295 from "../assets/hints/pt/faq_tilt_angle_img_5.png";
import _img_296 from "../assets/hints/pt/faq_tilt_angle_img_6.png";
import _img_297 from "../assets/hints/pt/faq_tilt_angle_img_7.png";
import _img_298 from "../assets/hints/pt/faq_tilt_angle_img_8.png";
import _img_299 from "../assets/hints/pt/faq_tilt_angle_img_9.png";
import _img_300 from "../assets/hints/pt/faq_vertical_aperture_img_1.png";
import _img_301 from "../assets/hints/pt/form_cloths_hints_img_1.png";
import _img_302 from "../assets/hints/pt/form_cloths_hints_img_2.png";
import _img_303 from "../assets/hints/pt/form_cloths_hints_img_3.png";
import _img_304 from "../assets/hints/pt/form_flotation_hints_img_1.jpg";
import _img_305 from "../assets/hints/pt/form_flotation_hints_img_2.jpg";
import _img_306 from "../assets/hints/pt/form_flotation_hints_img_3.jpg";
import _img_307 from "../assets/hints/pt/form_tow_cable_hints_img_1.png";
import _img_308 from "../assets/hints/pt/form_tow_cable_hints_img_2.jpg";
import _img_309 from "../assets/hints/pt/form_tow_cable_hints_img_3.png";
import _img_310 from "../assets/hints/pt/form_tow_cable_hints_img_4.png";
import _img_311 from "../assets/hints/pt/form_tow_cable_hints_img_5.jpg";
import _img_312 from "../assets/hints/pt/form_trawl_gates_hints_img_1.jpg";
import _img_313 from "../assets/hints/pt/form_trawl_gates_hints_img_2.jpg";
import _img_314 from "../assets/hints/pt/form_trawl_gates_hints_img_3.jpg";
import _img_315 from "../assets/hints/pt/form_trawl_gates_hints_img_4.jpg";
import _img_316 from "../assets/hints/pt/form_trawl_gates_hints_img_5.jpg";
import _img_317 from "../assets/hints/pt/form_trawl_gates_hints_img_6.jpg";
import _img_318 from "../assets/hints/pt/form_winches_hints_img_1.jpg";
import _img_319 from "../assets/hints/pt/form_winches_hints_img_2.jpg";

export const HINT_IMAGES: Record<string, Record<string, string>> = {
	"en": {
		"faq_door_angle_img_1": _img_0,
		"faq_door_aperture_img_1": _img_1,
		"faq_door_aperture_img_2": _img_2,
		"faq_door_aperture_img_3": _img_3,
		"faq_door_aperture_img_4": _img_4,
		"faq_door_aperture_img_5": _img_5,
		"faq_door_aperture_img_6": _img_6,
		"faq_door_aperture_img_7": _img_7,
		"faq_door_aperture_img_8": _img_8,
		"faq_door_classification_img_1": _img_9,
		"faq_door_classification_img_2": _img_10,
		"faq_door_classification_img_3": _img_11,
		"faq_door_classification_img_4": _img_12,
		"faq_door_forces_img_1": _img_13,
		"faq_door_forces_img_2": _img_14,
		"faq_door_forces_img_3": _img_15,
		"faq_door_gravity_img_1": _img_16,
		"faq_flotation_img_1": _img_17,
		"faq_flotation_img_2": _img_18,
		"faq_flotation_img_3": _img_19,
		"faq_flotation_img_4": _img_20,
		"faq_flotation_img_5": _img_21,
		"faq_flotation_img_6": _img_22,
		"faq_net_aperture_img_1": _img_23,
		"faq_net_aperture_img_2": _img_24,
		"faq_net_aperture_img_3": _img_25,
		"faq_net_efficiency_img_1": _img_26,
		"faq_net_efficiency_img_2": _img_27,
		"faq_net_efficiency_img_3": _img_28,
		"faq_net_length_img_1": _img_29,
		"faq_net_length_img_2": _img_30,
		"faq_net_length_img_3": _img_31,
		"faq_net_length_img_4": _img_32,
		"faq_pie_gallo_length_img_1": _img_33,
		"faq_pie_gallo_length_img_2": _img_34,
		"faq_tilt_angle_img_1": _img_35,
		"faq_tilt_angle_img_2": _img_36,
		"faq_tilt_angle_img_3": _img_37,
		"faq_tilt_angle_img_4": _img_38,
		"faq_tilt_angle_img_5": _img_39,
		"faq_tilt_angle_img_6": _img_40,
		"faq_tilt_angle_img_7": _img_41,
		"faq_tilt_angle_img_8": _img_42,
		"faq_tilt_angle_img_9": _img_43,
		"faq_vertical_aperture_img_1": _img_44,
		"form_cloths_hints_img_1": _img_45,
		"form_cloths_hints_img_2": _img_46,
		"form_cloths_hints_img_3": _img_47,
		"form_flotation_hints_img_1": _img_48,
		"form_flotation_hints_img_2": _img_49,
		"form_flotation_hints_img_3": _img_50,
		"form_tow_cable_hints_img_1": _img_51,
		"form_tow_cable_hints_img_2": _img_52,
		"form_tow_cable_hints_img_3": _img_53,
		"form_tow_cable_hints_img_4": _img_54,
		"form_tow_cable_hints_img_5": _img_55,
		"form_trawl_gates_hints_img_1": _img_56,
		"form_trawl_gates_hints_img_2": _img_57,
		"form_trawl_gates_hints_img_3": _img_58,
		"form_trawl_gates_hints_img_4": _img_59,
		"form_trawl_gates_hints_img_5": _img_60,
		"form_trawl_gates_hints_img_6": _img_61,
		"form_winches_hints_img_1": _img_62,
		"form_winches_hints_img_2": _img_63,
	},
	"es": {
		"faq_door_angle_img_1": _img_64,
		"faq_door_aperture_img_1": _img_65,
		"faq_door_aperture_img_2": _img_66,
		"faq_door_aperture_img_3": _img_67,
		"faq_door_aperture_img_4": _img_68,
		"faq_door_aperture_img_5": _img_69,
		"faq_door_aperture_img_6": _img_70,
		"faq_door_aperture_img_7": _img_71,
		"faq_door_aperture_img_8": _img_72,
		"faq_door_classification_img_1": _img_73,
		"faq_door_classification_img_2": _img_74,
		"faq_door_classification_img_3": _img_75,
		"faq_door_classification_img_4": _img_76,
		"faq_door_forces_img_1": _img_77,
		"faq_door_forces_img_2": _img_78,
		"faq_door_forces_img_3": _img_79,
		"faq_door_gravity_img_1": _img_80,
		"faq_flotation_img_1": _img_81,
		"faq_flotation_img_2": _img_82,
		"faq_flotation_img_3": _img_83,
		"faq_flotation_img_4": _img_84,
		"faq_flotation_img_5": _img_85,
		"faq_flotation_img_6": _img_86,
		"faq_net_aperture_img_1": _img_87,
		"faq_net_aperture_img_2": _img_88,
		"faq_net_aperture_img_3": _img_89,
		"faq_net_efficiency_img_1": _img_90,
		"faq_net_efficiency_img_2": _img_91,
		"faq_net_efficiency_img_3": _img_92,
		"faq_net_length_img_1": _img_93,
		"faq_net_length_img_2": _img_94,
		"faq_net_length_img_3": _img_95,
		"faq_net_length_img_4": _img_96,
		"faq_pie_gallo_length_img_1": _img_97,
		"faq_pie_gallo_length_img_2": _img_98,
		"faq_tilt_angle_img_1": _img_99,
		"faq_tilt_angle_img_2": _img_100,
		"faq_tilt_angle_img_3": _img_101,
		"faq_tilt_angle_img_4": _img_102,
		"faq_tilt_angle_img_5": _img_103,
		"faq_tilt_angle_img_6": _img_104,
		"faq_tilt_angle_img_7": _img_105,
		"faq_tilt_angle_img_8": _img_106,
		"faq_tilt_angle_img_9": _img_107,
		"faq_vertical_aperture_img_1": _img_108,
		"form_cloths_hints_img_1": _img_109,
		"form_cloths_hints_img_2": _img_110,
		"form_cloths_hints_img_3": _img_111,
		"form_flotation_hints_img_1": _img_112,
		"form_flotation_hints_img_2": _img_113,
		"form_flotation_hints_img_3": _img_114,
		"form_tow_cable_hints_img_1": _img_115,
		"form_tow_cable_hints_img_2": _img_116,
		"form_tow_cable_hints_img_3": _img_117,
		"form_tow_cable_hints_img_4": _img_118,
		"form_tow_cable_hints_img_5": _img_119,
		"form_trawl_gates_hints_img_1": _img_120,
		"form_trawl_gates_hints_img_2": _img_121,
		"form_trawl_gates_hints_img_3": _img_122,
		"form_trawl_gates_hints_img_4": _img_123,
		"form_trawl_gates_hints_img_5": _img_124,
		"form_trawl_gates_hints_img_6": _img_125,
		"form_winches_hints_img_1": _img_126,
		"form_winches_hints_img_2": _img_127,
	},
	"fr": {
		"faq_door_angle_img_1": _img_128,
		"faq_door_aperture_img_1": _img_129,
		"faq_door_aperture_img_2": _img_130,
		"faq_door_aperture_img_3": _img_131,
		"faq_door_aperture_img_4": _img_132,
		"faq_door_aperture_img_5": _img_133,
		"faq_door_aperture_img_6": _img_134,
		"faq_door_aperture_img_7": _img_135,
		"faq_door_aperture_img_8": _img_136,
		"faq_door_classification_img_1": _img_137,
		"faq_door_classification_img_2": _img_138,
		"faq_door_classification_img_3": _img_139,
		"faq_door_classification_img_4": _img_140,
		"faq_door_forces_img_1": _img_141,
		"faq_door_forces_img_2": _img_142,
		"faq_door_forces_img_3": _img_143,
		"faq_door_gravity_img_1": _img_144,
		"faq_flotation_img_1": _img_145,
		"faq_flotation_img_2": _img_146,
		"faq_flotation_img_3": _img_147,
		"faq_flotation_img_4": _img_148,
		"faq_flotation_img_5": _img_149,
		"faq_flotation_img_6": _img_150,
		"faq_net_aperture_img_1": _img_151,
		"faq_net_aperture_img_2": _img_152,
		"faq_net_aperture_img_3": _img_153,
		"faq_net_efficiency_img_1": _img_154,
		"faq_net_efficiency_img_2": _img_155,
		"faq_net_efficiency_img_3": _img_156,
		"faq_net_length_img_1": _img_157,
		"faq_net_length_img_2": _img_158,
		"faq_net_length_img_3": _img_159,
		"faq_net_length_img_4": _img_160,
		"faq_pie_gallo_length_img_1": _img_161,
		"faq_pie_gallo_length_img_2": _img_162,
		"faq_tilt_angle_img_1": _img_163,
		"faq_tilt_angle_img_2": _img_164,
		"faq_tilt_angle_img_3": _img_165,
		"faq_tilt_angle_img_4": _img_166,
		"faq_tilt_angle_img_5": _img_167,
		"faq_tilt_angle_img_6": _img_168,
		"faq_tilt_angle_img_7": _img_169,
		"faq_tilt_angle_img_8": _img_170,
		"faq_tilt_angle_img_9": _img_171,
		"faq_vertical_aperture_img_1": _img_172,
		"form_cloths_hints_img_1": _img_173,
		"form_cloths_hints_img_2": _img_174,
		"form_cloths_hints_img_3": _img_175,
		"form_flotation_hints_img_1": _img_176,
		"form_flotation_hints_img_2": _img_177,
		"form_flotation_hints_img_3": _img_178,
		"form_tow_cable_hints_img_1": _img_179,
		"form_tow_cable_hints_img_2": _img_180,
		"form_tow_cable_hints_img_3": _img_181,
		"form_tow_cable_hints_img_4": _img_182,
		"form_tow_cable_hints_img_5": _img_183,
		"form_trawl_gates_hints_img_1": _img_184,
		"form_trawl_gates_hints_img_2": _img_185,
		"form_trawl_gates_hints_img_3": _img_186,
		"form_trawl_gates_hints_img_4": _img_187,
		"form_trawl_gates_hints_img_5": _img_188,
		"form_trawl_gates_hints_img_6": _img_189,
		"form_winches_hints_img_1": _img_190,
		"form_winches_hints_img_2": _img_191,
	},
	"it": {
		"faq_door_angle_img_1": _img_192,
		"faq_door_aperture_img_1": _img_193,
		"faq_door_aperture_img_2": _img_194,
		"faq_door_aperture_img_3": _img_195,
		"faq_door_aperture_img_4": _img_196,
		"faq_door_aperture_img_5": _img_197,
		"faq_door_aperture_img_6": _img_198,
		"faq_door_aperture_img_7": _img_199,
		"faq_door_aperture_img_8": _img_200,
		"faq_door_classification_img_1": _img_201,
		"faq_door_classification_img_2": _img_202,
		"faq_door_classification_img_3": _img_203,
		"faq_door_classification_img_4": _img_204,
		"faq_door_forces_img_1": _img_205,
		"faq_door_forces_img_2": _img_206,
		"faq_door_forces_img_3": _img_207,
		"faq_door_gravity_img_1": _img_208,
		"faq_flotation_img_1": _img_209,
		"faq_flotation_img_2": _img_210,
		"faq_flotation_img_3": _img_211,
		"faq_flotation_img_4": _img_212,
		"faq_flotation_img_5": _img_213,
		"faq_flotation_img_6": _img_214,
		"faq_net_aperture_img_1": _img_215,
		"faq_net_aperture_img_2": _img_216,
		"faq_net_aperture_img_3": _img_217,
		"faq_net_efficiency_img_1": _img_218,
		"faq_net_efficiency_img_2": _img_219,
		"faq_net_efficiency_img_3": _img_220,
		"faq_net_length_img_1": _img_221,
		"faq_net_length_img_2": _img_222,
		"faq_net_length_img_3": _img_223,
		"faq_net_length_img_4": _img_224,
		"faq_pie_gallo_length_img_1": _img_225,
		"faq_pie_gallo_length_img_2": _img_226,
		"faq_tilt_angle_img_1": _img_227,
		"faq_tilt_angle_img_2": _img_228,
		"faq_tilt_angle_img_3": _img_229,
		"faq_tilt_angle_img_4": _img_230,
		"faq_tilt_angle_img_5": _img_231,
		"faq_tilt_angle_img_6": _img_232,
		"faq_tilt_angle_img_7": _img_233,
		"faq_tilt_angle_img_8": _img_234,
		"faq_tilt_angle_img_9": _img_235,
		"faq_vertical_aperture_img_1": _img_236,
		"form_cloths_hints_img_1": _img_237,
		"form_cloths_hints_img_2": _img_238,
		"form_cloths_hints_img_3": _img_239,
		"form_flotation_hints_img_1": _img_240,
		"form_flotation_hints_img_2": _img_241,
		"form_flotation_hints_img_3": _img_242,
		"form_tow_cable_hints_img_1": _img_243,
		"form_tow_cable_hints_img_2": _img_244,
		"form_tow_cable_hints_img_3": _img_245,
		"form_tow_cable_hints_img_4": _img_246,
		"form_tow_cable_hints_img_5": _img_247,
		"form_trawl_gates_hints_img_1": _img_248,
		"form_trawl_gates_hints_img_2": _img_249,
		"form_trawl_gates_hints_img_3": _img_250,
		"form_trawl_gates_hints_img_4": _img_251,
		"form_trawl_gates_hints_img_5": _img_252,
		"form_trawl_gates_hints_img_6": _img_253,
		"form_winches_hints_img_1": _img_254,
		"form_winches_hints_img_2": _img_255,
	},
	"pt": {
		"faq_door_angle_img_1": _img_256,
		"faq_door_aperture_img_1": _img_257,
		"faq_door_aperture_img_2": _img_258,
		"faq_door_aperture_img_3": _img_259,
		"faq_door_aperture_img_4": _img_260,
		"faq_door_aperture_img_5": _img_261,
		"faq_door_aperture_img_6": _img_262,
		"faq_door_aperture_img_7": _img_263,
		"faq_door_aperture_img_8": _img_264,
		"faq_door_classification_img_1": _img_265,
		"faq_door_classification_img_2": _img_266,
		"faq_door_classification_img_3": _img_267,
		"faq_door_classification_img_4": _img_268,
		"faq_door_forces_img_1": _img_269,
		"faq_door_forces_img_2": _img_270,
		"faq_door_forces_img_3": _img_271,
		"faq_door_gravity_img_1": _img_272,
		"faq_flotation_img_1": _img_273,
		"faq_flotation_img_2": _img_274,
		"faq_flotation_img_3": _img_275,
		"faq_flotation_img_4": _img_276,
		"faq_flotation_img_5": _img_277,
		"faq_flotation_img_6": _img_278,
		"faq_net_aperture_img_1": _img_279,
		"faq_net_aperture_img_2": _img_280,
		"faq_net_aperture_img_3": _img_281,
		"faq_net_efficiency_img_1": _img_282,
		"faq_net_efficiency_img_2": _img_283,
		"faq_net_efficiency_img_3": _img_284,
		"faq_net_length_img_1": _img_285,
		"faq_net_length_img_2": _img_286,
		"faq_net_length_img_3": _img_287,
		"faq_net_length_img_4": _img_288,
		"faq_pie_gallo_length_img_1": _img_289,
		"faq_pie_gallo_length_img_2": _img_290,
		"faq_tilt_angle_img_1": _img_291,
		"faq_tilt_angle_img_2": _img_292,
		"faq_tilt_angle_img_3": _img_293,
		"faq_tilt_angle_img_4": _img_294,
		"faq_tilt_angle_img_5": _img_295,
		"faq_tilt_angle_img_6": _img_296,
		"faq_tilt_angle_img_7": _img_297,
		"faq_tilt_angle_img_8": _img_298,
		"faq_tilt_angle_img_9": _img_299,
		"faq_vertical_aperture_img_1": _img_300,
		"form_cloths_hints_img_1": _img_301,
		"form_cloths_hints_img_2": _img_302,
		"form_cloths_hints_img_3": _img_303,
		"form_flotation_hints_img_1": _img_304,
		"form_flotation_hints_img_2": _img_305,
		"form_flotation_hints_img_3": _img_306,
		"form_tow_cable_hints_img_1": _img_307,
		"form_tow_cable_hints_img_2": _img_308,
		"form_tow_cable_hints_img_3": _img_309,
		"form_tow_cable_hints_img_4": _img_310,
		"form_tow_cable_hints_img_5": _img_311,
		"form_trawl_gates_hints_img_1": _img_312,
		"form_trawl_gates_hints_img_2": _img_313,
		"form_trawl_gates_hints_img_3": _img_314,
		"form_trawl_gates_hints_img_4": _img_315,
		"form_trawl_gates_hints_img_5": _img_316,
		"form_trawl_gates_hints_img_6": _img_317,
		"form_winches_hints_img_1": _img_318,
		"form_winches_hints_img_2": _img_319,
	},
};
